var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6953 12C17.1137 12 21.5233 6 21.5233 6C21.5233 6 17.192 0 10.6953 0C4.19859 0 0 6.25125 0 6.25125C0 6.25125 4.27688 12 10.6953 12ZM10.7617 10.2C13.0813 10.2 14.9617 8.3196 14.9617 6C14.9617 3.6804 13.0813 1.8 10.7617 1.8C8.44206 1.8 6.56166 3.6804 6.56166 6C6.56166 8.3196 8.44206 10.2 10.7617 10.2ZM10.7617 7.8C11.7558 7.8 12.5617 6.99411 12.5617 6C12.5617 5.00589 11.7558 4.2 10.7617 4.2C9.76754 4.2 8.96166 5.00589 8.96166 6C8.96166 6.99411 9.76754 7.8 10.7617 7.8Z",
    fill: "#716C67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.91ac622110c2ec42e73684e86c1acb80.svg";
export { ForwardRef as ReactComponent };